// ie
import 'core-js';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// custom
import api from './api';
import util from './utils';
import './filter/index';
// 全局组件
import '@/components/index';

// 全局样式
import './styles/index.scss';
import './styles/animate.css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './element-variables.scss';
import vueSeamlessScroll from 'vue-seamless-scroll';
// import * as echarts from 'echarts';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import Vant from 'vant';
import 'vant/lib/index.css';

// init
// import {
//     initData
// } from './utils/initData';

Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(vueSeamlessScroll);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$util = util;
// Vue.prototype.$echarts = echarts;

// initData();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});
